namespace Matrix.Rebalancer {
    export class SecurityOverrideColumns {
        static columnsKey = 'Rebalancer.SecurityOverride';
    }
}
